import React, { useCallback, useEffect, useState } from "react";
import "./Passbook.css";
import { Helmet } from "react-helmet";
import Sidebar from "../Sidebar";
import DeshBoardFooter from "../DeshBoardFooter";
import { useAuth } from "../../../Store/AuthContext";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import { Link, useParams } from "react-router-dom";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import axios from "axios";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
import ReceiptModal from "./ReceiptModal";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function PassbookTransactionDetails() {
  let { transactionid } = useParams();
  // console.log(transactionid);
  const { userID, RendomTokenfetch, profileData } = useAuth();
  const [TransactionData, setTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Sample transaction data - replace with your actual data
  // Sample transaction data

  const FetchTransaction = useCallback(async () => {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("transactionId", transactionid);
    setLoading(true);
    try {
      await axios
        .post(`${WebsiteAPIurl}wallet_passbook_details`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.status === "1") {
            setTransactionData(response.data.WalletpassbookData);
          }
          if (response.data.status === "0") {
            setTransactionData([]);
            NotifyMessageNoReload(response.data.message, "danger");
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, transactionid, userID]);

  useEffect(() => {
    FetchTransaction();
  }, [FetchTransaction]);

  const transaction = {
    name: profileData?.username || "",
    email: profileData?.email || "",
    phone: profileData?.number || "",
    address: profileData?.address || "",
    amount: TransactionData?.amount || 0,
    referenceNo: TransactionData?.referenceNo || "",
    order_id: TransactionData?.order_id || "",
    create_date: TransactionData?.create_date || "",
    payment_date: TransactionData?.date_time || "",
    payment_status: TransactionData?.payment_status || "",
    credit_debit_type: TransactionData?.credit_debit_type || "",
    transactionId: TransactionData?.transactionId || "",
    receipt_id: TransactionData?.receipt_id || "",
    description: TransactionData?.description || "",
    comment: TransactionData?.comment || "",
    lead_status: TransactionData?.lead_status || "",
    lead_id: TransactionData?.lead_id || "",
    wallet_transaction_id: TransactionData?.wallet_transaction_id || "",
  };
  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "Passbook", pagelink: "passbook" },
            { name: "Passbook Transaction Details" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer walletDetails">
            <div
              className="newspapermultyupdatebox"
              style={{ borderBottom: "unset" }}
            >
              <div className="row my-1">
                <div className="col-lg-12 col-md-12  mt-1">
                  <Link
                    to="/passbook"
                    className="DefaultHoverbtn handleServiceStatus"
                  >
                    <span>
                      <i className="fa fa-arrow-left me-2"></i>
                    </span>{" "}
                    Back
                  </Link>
                </div>
              </div>
            </div>

            <div
              className={`transaction_header p-4 mb-4 border border-success  ${
                transaction.credit_debit_type === "1"
                  ? "border-success"
                  : "border-danger"
              }`}
              style={{ maxWidth: "920px", backgroundColor: "rgb(229 229 229)" }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="">
                  <h4 className="mb-1 text-dark fw-600">Payment </h4>
                  <p className="mb-0 text-dark">
                    Completed on {transaction.payment_date}
                  </p>
                </div>
                <div className="text-md-end">
                  <h3 className="text-light mb-0">
                    {/* ₹{transaction.amount} */}
                    <span
                      className={` ${
                        transaction.credit_debit_type === "1"
                          ? "text-success"
                          : "text-danger"
                      }`}
                    >
                      {transaction.credit_debit_type === "1"
                        ? `+₹${transaction.amount}`
                        : `-₹${transaction.amount}`}
                    </span>
                  </h3>
                  <span
                    className={`badge ${
                      transaction.credit_debit_type === "1"
                        ? "bg-success"
                        : "bg-danger"
                    }`}
                  >
                    {transaction.credit_debit_type === "1" ? "Credit" : "Debit"}
                  </span>
                </div>
              </div>
            </div>
            <div className="payment-container" style={{ maxWidth: "920px" }}>
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  {/* <div className="divider"></div> */}

                  <div className="details-section">
                    <h3>
                      <i className="fa fa-info-circle me-2"></i>Transaction
                      Details
                    </h3>

                    <table className="details-table">
                      <tbody>
                        <tr>
                          <td className="label">Transaction ID</td>
                          <td>{transaction.transactionId}</td>
                        </tr>
                        <tr>
                          <td className="label">Reference No.</td>
                          <td>{transaction.referenceNo}</td>
                        </tr>
                        <tr>
                          <td className="label">Receipt ID</td>
                          <td>{transaction.receipt_id}</td>
                        </tr>
                        <tr>
                          <td className="label">Status</td>
                          <td>
                            <span
                              className={`badge ${
                                transaction.payment_status === "1"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {transaction.payment_status === "1"
                                ? "Complete"
                                : "Falid"}
                            </span>
                          </td>
                        </tr>

                        <tr>
                          <td className="label">Payment Type</td>
                          <td>
                            {" "}
                            <span
                              className={`badge ${
                                transaction.credit_debit_type === "1"
                                  ? "bg-info"
                                  : "bg-danger"
                              }`}
                            >
                              {transaction.credit_debit_type === "1"
                                ? "Credit"
                                : "Debit"}
                            </span>
                          </td>
                        </tr>
                        {transaction.lead_id && (
                          <tr>
                            <td className="label">Lead ID</td>
                            <td>{transaction.lead_id}</td>
                          </tr>
                        )}

                        <tr>
                          <td className="label">Payment Date</td>
                          <td>{transaction.payment_date}</td>
                        </tr>
                        <tr>
                          <td className="label">Description</td>
                          <td>{transaction.description}</td>
                        </tr>
                        {transaction.comment && (
                          <tr>
                            <td className="label">Comment</td>
                            <td>{transaction.comment}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* <div className="divider"></div>

                  <div className="details-section">
                    <h3>
                      <i className="fa fa-user me-2"></i>User Details
                    </h3>

                    <table className="details-table">
                      <tbody>
                        <tr>
                          <td className="label">User Name</td>
                          <td>{transaction.name}</td>
                        </tr>
                        <tr>
                          <td className="label">Mobile Number</td>
                          <td>{transaction.phone}</td>
                        </tr>
                        <tr>
                          <td className="label">Email Address</td>
                          <td>{transaction.email}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}
                </div>
                <div className="divider"></div>
                <div className="col-xl-12 col-lg-12 col-md-12 text-center">
                  <div>
                    <button
                      className="theme-btn btn-style-three submitbtn"
                      style={{ marginRight: "12px" }}
                      onClick={() => setShowModal(true)}
                    >
                      <i className="fa fa-download mx-2" aria-hidden="true"></i>{" "}
                      Download Receipt
                    </button>
                    <ReceiptModal
                      show={showModal}
                      onClose={() => setShowModal(false)}
                      transaction={transaction}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
